export function isCampaignActive(
  campaign,
  { placement, now = Date.now() } = {},
) {
  if (!campaign?.enabled) return false;
  if (placement && campaign.placement !== placement) return false;

  const publicationMode = campaign.publicationMode || "scheduled";

  if (publicationMode === "manual") return true;
  if (publicationMode !== "scheduled") return false;

  const startTime = Date.parse(campaign.startAt);
  const endTime = Date.parse(campaign.endAt);

  if (!Number.isFinite(startTime) || !Number.isFinite(endTime)) return false;

  return now >= startTime && now <= endTime;
}
